import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import * as React from "react";
import { Button } from "reactstrap";
import { uniprotLink } from "../../../utils/toolsReact";
import { ProteinResponse } from "../../../api/openapi-generator";

interface Props {
  targets: ProteinResponse[],
  selected: ProteinResponse | null,
  selectTarget (target: ProteinResponse | null): void,
}

class IsoformTable extends React.PureComponent<Props> {

  isSelected = (data: ProteinResponse) => (
    this.props.selected && data.id === this.props.selected.id
  )

  uniprotBodyTemplate = ({ uniprot }: ProteinResponse) => <>
    {uniprotLink(uniprot)}
    {/* {canonical && <span> <Badge color="primary" pill>canonical</Badge></span>} */}
  </>

  lengthBodyTemplate = ({ sequence }: ProteinResponse) => (
    `${sequence.length} residues`
  )

  selectBodyTemplate = (data: ProteinResponse) => {
    const selected = this.isSelected(data);
    return (
      <Button
        size="sm"
        title={`Select ${data.uniprot} as target isoform`}
        onClick={() => this.props.selectTarget(data)}
        disabled={selected ?? false}
      >
        {selected ? 'Selected' : 'Select isoform'}
      </Button>
    );
  }

  rowClassName = (data: ProteinResponse) => (
    this.isSelected(data) ? 'p-highlight' : undefined
  )

  render() {
    if (!this.props.targets) {
      return null;
    }
    return <div>
      <DataTable
        value={this.props.targets} dataKey="number"
        className="p-datatable-sm p-datatable-striped ll-known-target-table"
        removableSort
        rowClassName={this.rowClassName}
      >
        <Column field="code" header="Protein Code" sortable headerClassName="ll-header-cell" />
        <Column body={this.uniprotBodyTemplate} field="uniprot" header="UniProtKB" sortable headerClassName="ll-header-cell" />
        <Column body={this.lengthBodyTemplate} field="sequence.length" header="Length" sortable headerClassName="ll-header-cell" />
        <Column body={this.selectBodyTemplate} bodyStyle={{ textAlign: 'center' }} />
      </DataTable>
    </div>
  }
}

export default IsoformTable;
